import { useTranslation } from "react-i18next";
import BottomLine from "~/src/components/BottomLine";
import { RadioButtonChecked, RadioButtonUnchecked } from "~/src/components/Form/Radio";
import { AccordionDefault } from "../../../../components/Accordion/AccordionDefault";
import { TermiskData, TermiskMap } from "./HjortTypes";

type TermiskRegistreringProps = {
  slots: TermiskData[];
  termiskMap: TermiskMap;
  onChange: (key: string, value: boolean) => void;
  disabled?: boolean;
  showValidation?: boolean;
};

export default function TermiskRegistrering({
  slots,
  termiskMap,
  onChange,
  disabled,
  showValidation,
}: TermiskRegistreringProps): JSX.Element | null {
  const { t } = useTranslation();

  if (slots.length === 0) return null;

  const hasUnanswered = slots.some(
    (slot) => termiskMap[slot.key] === null || termiskMap[slot.key] === undefined,
  );

  return (
    <AccordionDefault
      title={t("pages.registrerArt.hjort.termisk.title")}
      defaultOpen={true}
      errorMessage={
        showValidation && hasUnanswered ? t("pages.registrerArt.hjort.termisk.påkrevd") : undefined
      }
      info={t("pages.registrerArt.hjort.termisk.infoTekst")}
      useErrorIcon
    >
      <div>
        {slots.map((slot, slotIndex) => {
          const isLast = slotIndex === slots.length - 1;
          const slotNumber = slot.index + 1;
          const typeCount = slots.filter((s) => s.dyrTypeKey === slot.dyrTypeKey).length;
          const label = typeCount > 1 ? `${slot.label} ${slotNumber}` : slot.label;
          const terrengLabel =
            slot.terreng === "Innmark"
              ? t("pages.fellingsinfo.innmark")
              : t("pages.fellingsinfo.utmark");
          const jaId = `termisk-ja-${slot.key}`;
          const neiId = `termisk-nei-${slot.key}`;

          return (
            <div key={slot.key}>
              <div className="flex items-center justify-between gap-4 py-3 px-1">
                <span className="text-xl">
                  {label} <span className="text-base font-normal">({terrengLabel})</span>
                </span>
                <div className="flex items-center gap-6 shrink-0">
                  <label htmlFor={jaId} className="flex items-center cursor-pointer select-none">
                    <input
                      type="radio"
                      id={jaId}
                      name={`termisk-${slot.key}`}
                      checked={termiskMap[slot.key] === true}
                      onChange={() => onChange(slot.key, true)}
                      disabled={disabled}
                      className="sr-only peer"
                    />
                    <RadioButtonUnchecked />
                    <RadioButtonChecked />
                    <span className="text-xl">{t("pages.registrerArt.hjort.termisk.ja")}</span>
                  </label>
                  <label htmlFor={neiId} className="flex items-center cursor-pointer select-none">
                    <input
                      type="radio"
                      id={neiId}
                      name={`termisk-${slot.key}`}
                      checked={termiskMap[slot.key] === false}
                      onChange={() => onChange(slot.key, false)}
                      disabled={disabled}
                      className="sr-only peer"
                    />
                    <RadioButtonUnchecked />
                    <RadioButtonChecked />
                    <span className="text-xl">{t("pages.registrerArt.hjort.termisk.nei")}</span>
                  </label>
                </div>
              </div>
              {!isLast && <BottomLine />}
            </div>
          );
        })}
      </div>
    </AccordionDefault>
  );
}
